import writtenNumber from "written-number";

const useConverter = (lang) => {
  const convertNumberToWords = (number, lang) => {
    writtenNumber.defaults.lang = lang;

    const [integerPart, decimalPart] = String(number).split(".");

    const integerWords = writtenNumber(integerPart);

    let result = lang==="ar" ? `${integerWords}  - ريال سعودى -  ` :`${integerWords} (S.R) ` ;

    if (decimalPart && decimalPart !== "00") {
      const decimalWords = writtenNumber(decimalPart);
      result += lang ==="ar" ? ` و ${decimalWords} (هللة)`:` and ${decimalWords} (Halala)`;
    }

    return result;
  };

  return { convertNumberToWords };
};

export default useConverter;